import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { onAnimStackReady } from "../main/animStack";

onAnimStackReady(() => {
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }

  const EASE_OUT = "power2.out";
  const EASE_INOUT = "power2.inOut";
  const DURATION = 0.9;
  const START_POS = "top 85%";
  const STAGGER = 0.08;

  function reveal(target, vars) {
    return gsap.from(
      target,
      Object.assign(
        {
          duration: DURATION,
          ease: EASE_OUT,
          opacity: 0,
          scrollTrigger: {
            trigger: target,
            start: START_POS,
            toggleActions: "play none none none",
            once: true,
          },
        },
        vars || {},
      ),
    );
  }

// ==========================================================================
  // HERO
  // ==========================================================================
  const heroSection = document.querySelector(".home-hero");
  if (heroSection) {
    gsap.to(".home-hero__slide-img", {
      yPercent: 12,
      ease: "none",
      scrollTrigger: {
        trigger: heroSection,
        start: "top top",
        end: "bottom top",
        scrub: true,
      },
    });

    // Updated Timeline for a premium, buttery-smooth reveal
    const heroTl = gsap.timeline({
      delay: 0.2, // A tiny bit longer delay so the page fully renders first
      defaults: { 
        ease: "power3.out", // power3 is much smoother and more elegant than power2
        duration: 1.2       // Slightly longer duration for a "floating" feel
      },
    });
    
    heroTl
      .to(".home-hero h1", {
        opacity: 1,
        y: 0,
        // Removed clipPath to stop the "junky" stuttering
      })
      .to(
        ".home-hero h2",
        {
          opacity: 1,
          y: 0,
        },
        "-=1.0" // Tighter overlap so the H2 follows the H1 beautifully
      )
      .to(
        ".home-hero .text--body-1",
        { 
          duration: 1.0, 
          opacity: 1, 
          y: 0 
        },
        "-=0.9"
      )
      .to(
        '.home-hero a[href="#service"]', // The SCROLL button
        {
          duration: 0.9,
          opacity: 1,
          scale: 1,
          ease: "back.out(1.4)", // Softened the bounce slightly so it doesn't look cartoonish
        },
        "-=0.8"
      );
  }
  // ==========================================================================
  // SERVICE
  // ==========================================================================
  reveal(".home-service__title", { y: 30 });

  ScrollTrigger.batch(".home-service__card-item", {
    start: START_POS,
    once: true,
    onEnter: function (batch) {
      gsap.from(batch, {
        duration: DURATION,
        opacity: 0,
        y: 40,
        stagger: STAGGER,
        ease: EASE_OUT,
        overwrite: "auto",
      });
    },
  });

  reveal(".home-service__button", { y: 20, duration: 0.7 });

  // ==========================================================================
  // RESIDENTIAL
  // ==========================================================================
  reveal(".home-residential__bg", {
    opacity: 0,
    scale: 1.08,
    duration: 1.4,
    ease: EASE_INOUT,
  });
  reveal(".home-residential__gallery", { y: 50, duration: 1.1 });
  reveal(".home-residential__content-title", { y: 24 });
  reveal(".home-residential__content-description", { y: 16, duration: 0.8 });

  // ==========================================================================
  // VALUES
  // ==========================================================================
  document
    .querySelectorAll(".home-values__item")
    .forEach(function (item, index) {
      const media = item.querySelector(".home-values__media");
      const content = item.querySelector(".home-values__content");
      if (!media || !content) return;

      const isEven = index % 2 === 0;
      const mediaFromX = isEven ? 120 : -120;
      const contentFromX = isEven ? -120 : 120;

      gsap.from(media, {
        duration: 1.1,
        opacity: 0,
        x: mediaFromX,
        ease: EASE_OUT,
        scrollTrigger: {
          trigger: item,
          start: START_POS,
          toggleActions: "play none none none",
          once: true,
        },
      });

      gsap.from(content, {
        duration: 1.1,
        opacity: 0,
        x: contentFromX,
        ease: EASE_OUT,
        scrollTrigger: {
          trigger: item,
          start: START_POS,
          toggleActions: "play none none none",
          once: true,
        },
      });
    });

  // ==========================================================================
  // PORTFOLIO
  // ==========================================================================
  reveal(".home-portfolio__title", { y: 24 });
  reveal(".home-portfolio__description", { y: 16, duration: 0.8 });
  reveal(".home-portfolio__slider", { x: 60, duration: 1.1 });

  // ==========================================================================
  // PRINCIPAL
  // ==========================================================================
  const principalImg = document.querySelector("#image-198-1133");
  const principalContent = document.querySelector("#div_block-199-1133");
  //   if (principalImg) {
  //     gsap.from(principalImg, {
  //       duration: 1.1,
  //       opacity: 0,
  //       x: -60,
  //       ease: EASE_OUT,
  //       scrollTrigger: {
  //         trigger: principalImg,
  //         start: "top 90%",
  //         toggleActions: "play none none none",
  //         once: true,
  //       },
  //     });
  //   }
  if (principalContent) {
    gsap.from(principalContent.children, {
      duration: 0.8,
      opacity: 0,
      y: 30,
      stagger: 0.12,
      ease: EASE_OUT,
      scrollTrigger: {
        trigger: principalContent,
        start: "top 90%",
        toggleActions: "play none none none",
        once: true,
      },
    });
  }

  // ==========================================================================
  // CLIENTS
  // ==========================================================================
  const clientsTitle = document.querySelector(
    "#section-211-1133 .ct-headline.text--head-2",
  );
  if (clientsTitle) reveal(clientsTitle, { y: 24 });

  ScrollTrigger.batch(".home-clients__slide", {
    start: START_POS,
    once: true,
    onEnter: function (batch) {
      gsap.from(batch, {
        duration: 0.7,
        opacity: 0,
        y: 30,
        stagger: 0.06,
        ease: EASE_OUT,
        overwrite: "auto",
      });
    },
  });

  // ==========================================================================
  // TESTIMONIALS
  // ==========================================================================
  const testimonialTitle = document.querySelector(
    "#section-247-1133 .ct-headline.text--display-1",
  );
  if (testimonialTitle) reveal(testimonialTitle, { y: 24 });

  reveal(".home-review__slider", { y: 40, duration: 1.1 });
});